<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Demance client N° FC{{ annee }}-{{ numero_annee }}</strong>
          </div>
          <b-form id="fiche-form">
            <b-row>
              <b-col sm="6">
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> CONTACT</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="civilite"><strong>Civilité  </strong></label>
                      </b-col>
                      <b-col>
                        <b-form-radio-group
                          :disabled="isDisabled()"
                          id="radio-group-civilite"
                          v-model="contact_civ"
                          name="radio-civilite"
                          :class="{hasError: errors.contact_civ !== ''}"
                        >
                          <b-form-radio value="Mme">Madame</b-form-radio>
                          <b-form-radio value="M.">Monsieur</b-form-radio>
                        </b-form-radio-group>
                        <span class="field-error">{{ errors.contact_civ }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="nom"><strong>Nom</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="contact_nom" :class="{hasError: errors.contact_nom !== ''}" :disabled="isDisabled()"/>
                        <span class="field-error">{{ errors.contact_nom }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="prenom"><strong>Prénom</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="contact_prenom" :disabled="isDisabled()"/>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="fonction"><strong>Fonction</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-select v-model="contact_fonction" :class="{hasError: errors.contact_fonction !== ''}" :disabled="isDisabled()">
                          <b-form-select-option value="null" disabled>-- Sélectionner --</b-form-select-option>
                          <b-form-select-option value="Employeur">Employeur</b-form-select-option>
                          <b-form-select-option value="Assuré">Assuré</b-form-select-option>
                          <b-form-select-option value="Bénéficiaire">Bénéficiaire</b-form-select-option>
                          <b-form-select-option value="Autre">Autre</b-form-select-option>
                        </b-form-select>
                        <span class="field-error">{{ errors.contact_fonction }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="tel"><strong>N° Tél.</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="contact_tel" :class="{hasError: errors.contact_tel !== ''}" :disabled="isDisabled()"/>
                        <span class="field-error">{{ errors.contact_tel }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="precision"><strong>Précisions</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="contact_precision" :disabled="isDisabled()"/>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="email"><strong>Email</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="contact_email" :class="{hasError: errors.contact_email !== ''}" :disabled="isDisabled()"/>
                        <span class="field-error">{{ errors.contact_email }}</span>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> OBJET DE LA DEMANDE CLIENTE</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col>
                        <b-form-textarea rows="6" max-rows="6" id="demandeObjet" v-model="demande_objet" :disabled="isDisabled('demande_objet')"/>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> PRECISIONS SUR LE PRODUIT</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="gamme"><strong>Gamme</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-select ref="gammeSelect"
                              :disabled="isDisabled()"
                              id="gammeSelect"
                              :plain="true"
                              :options="produitOptions"
                              v-model="selectedProduit"
                              :class="{hasError: errors.selectedProduit !== ''}"
                        >
                          <template #first>
                            <b-form-select-option :value="null">-- Sélectionner --</b-form-select-option>
                          </template>
                        </b-form-select>
                        <span class="field-error">{{ errors.selectedProduit }}</span>
                      </b-col>
                      <b-col sm="2">
                        <label for="produitPrecision"><strong>Obs.</strong></label>
                      </b-col>
                      <b-col sm="3">
                        <b-form-input type="text" v-model="produit_precision" :disabled="isDisabled()"/>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="garantie"><strong>Garantie</strong></label>
                      </b-col>
                      <b-col sm="5">
                        <b-form-select ref="garantieSelect"
                              id="garantieSelect"
                              :plain="true"
                              :options="garantieOptions"
                              v-model="selectedGarantie"
                              :class="{hasError: errors.selectedGarantie !== ''}"
                        >
                          <template #first>
                            <b-form-select-option :value="null">-- Sélectionner --</b-form-select-option>
                          </template>
                        </b-form-select>
                        <span class="field-error">{{ errors.selectedGarantie }}</span>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-card no-body class="bloc-suivi">
                  <div class="card-smallHeader card-header-action">
                    <span style="color: #d9418b" class="mr-2"><b> SUIVI DU TRAITEMENT DE LA DEMANDE</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="">
                      <b-col sm="3" class="suivi-fiche">
                        <span for="date_creation" class="suivi-date">{{ getFormattedDateTime(fiche.date_appel) }}</span><br>
                        <span v-if="fiche.createur" class="suivi-gestionnaire"><i>{{ fiche.createur.prenom.charAt(0) }}. {{ fiche.createur.nom.charAt(0).toUpperCase()+fiche.createur.nom.slice(1).toLowerCase() }}</i></span>
                      </b-col>
                      <b-col>
                        <span for="texte">Init. Fiche</span>
                      </b-col>
                    </b-row>
                    <b-row class="" v-for="(suivi, index) in ficheSuivis" :key="suivi.id">
                      <b-col sm="3" class="suivi-fiche">
                        <span class="suivi-date">{{ getFormattedDateTime(suivi.date_creation) }}</span><br>
                        <span v-if="suivi.gestionnaire" class="suivi-gestionnaire"><i>{{ suivi.gestionnaire.prenom.charAt(0) }}. {{ suivi.gestionnaire.nom.charAt(0).toUpperCase()+suivi.gestionnaire.nom.slice(1).toLowerCase() }}</i></span>
                      </b-col>
                      <b-col>
                        <span class="d-inline-block" v-html="suivi.texte"></span>
                        <i v-if="canDeleteSuivi(suivi, index)" class="d-inline-block fa fa-trash text-danger pull-right clickable align-middle" @click="deleteSuivi(suivi)"></i>
                      </b-col>
                    </b-row>
                    <b-row v-if="codeStatut !== 'BR'" class="mb-1">
                      <b-col sm="3">
                        <label for="note_demande"><strong>Ajout note</strong></label><br>
                        <span>
                          <b-col sm="2">
                            <b-form-radio-group
                              :disabled="isDisabled()"
                              id="radio-group-note"
                              v-model="type_suivi"
                              name="radio-type_suivi"
                            >
                              <b-form-radio value="C">Ech.Client</b-form-radio>
                              <b-form-radio value="I">Ech.Interne</b-form-radio>
                            </b-form-radio-group>
                          </b-col>
                        </span>
                      </b-col>
                      <b-col>
                        <b-form-textarea rows="3" max-rows="3" id="noteDemande" v-model="note_demande" :disabled="isDisabled('note_demande')"/>
                        <span class="field-error">{{ errors.note_demande }}</span>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col sm="6">
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> EMPLOYEUR</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="raison_sociale"><strong>RS</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="structure_nom" :disabled="isDisabled()"/>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="siren"><strong>SIREN</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="structure_siren" :disabled="isDisabled()"/>
                      </b-col>
                      <b-col sm="2">
                        <label for="nic"><strong>NIC</strong></label>
                      </b-col>
                      <b-col sm="3">
                        <b-form-input type="text" v-model="structure_nic" :disabled="isDisabled()"/>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> ASSURE / BENEFICIAIRE</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="nom"><strong>Nom</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="beneficiaire_nom" :disabled="isDisabled()"/>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="prenom"><strong>Prénom</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="beneficiaire_prenom" :disabled="isDisabled()"/>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="num_ss"><strong>N° SS</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-input type="text" v-model="beneficiaire_nir" :disabled="isDisabled()"/>
                      </b-col>
                      <b-col sm="2">
                        <label for="cle"><strong>Clé</strong></label>
                      </b-col>
                      <b-col sm="3">
                        <b-form-input type="text" v-model="beneficiaire_cle" :disabled="isDisabled()"/>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> VERIFICATIONS REALISEES PAR LE CONSEILLER</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col>
                        <b-form-textarea rows="6" max-rows="6" id="demandeVerification" v-model="demande_verification" :disabled="isDisabled('demande_verification')"/>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color: #d9418b" class="mr-2"><b> CRITICITE ET PRISE EN CHARGE</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="criticite"><strong>Criticité</strong></label>
                      </b-col>
                      <b-col>
                        <b-form-select v-model="criticite" :disabled="isDisabled()">
                          <b-form-select-option value="S">Standard</b-form-select-option>
                          <b-form-select-option value="R">Réclamation</b-form-select-option>
                          <b-form-select-option value="U">Urgent</b-form-select-option>
                        </b-form-select>
                      </b-col>
                      <b-col sm="2">
                        <label for="libelleStatut"><strong>Statut</strong></label>
                      </b-col>
                      <b-col sm="3">
                        <!-- <b-form-input type="text" v-model="statut" /> -->
                        <span class="field-error" style="margin-top:5px"><strong>{{ libelleStatut }}</strong></span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="domaine"><strong>Dest.</strong></label>
                      </b-col>
                      <b-col sm="5">
                        <b-form-select v-model="domaine" :options="domaineOptions" @change="getGestionnaires(domaine)" :disabled="isDisabled()">
                          <template v-slot:first>
                            <b-form-select-option :value="null">-- Sélectionner --</b-form-select-option>
                          </template>
                        </b-form-select>
                        <span class="field-error">{{ errors.domaine }}</span>
                      </b-col>
                      <b-col sm="2" v-if="codeStatut !== 'CL' && codeStatut !== 'AV' && codeStatut !== 'BR'">
                        <label for="domaine"><strong>Suivi</strong></label>
                      </b-col>
                      <b-col sm="3" v-if="codeStatut !== 'CL' && codeStatut !== 'AV' && codeStatut !== 'BR'">
                        <b-form-select ref="gestionnaireSelect"
                              :disabled="isDisabled()"
                              id="gestionnaireSelect"
                              :plain="true"
                              :options="gestionnaireOptions"
                              v-model="gestionnaire"
                              :class="{hasError: errors.gestionnaire !== ''}"
                        >
                          <template #first>
                            <b-form-select-option :value="null">-- Sélectionner --</b-form-select-option>
                          </template>
                        </b-form-select>
                        <span class="field-error">{{ errors.gestionnaire }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1" v-if="qualification_id !== null">
                      <b-col sm="2">
                        <label for="qualification"><strong>Qualification</strong></label>
                      </b-col>
                      <b-col sm="5">
                        <span>{{ motifCloture.libelle }}</span>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-card style="border:none!important">
                  <b-row class="mb-2" v-if="codeStatut !== 'CL' && codeStatut !== 'AV' && codeStatut !== 'BR'">
                    <b-col sm="3">
                      <label for="qualification"><strong>Qualification :</strong></label>
                    </b-col>
                    <b-col sm="5">
                      <b-form-select ref="qualificationSelect"
                              :disabled="isDisabled()"
                              id="qualificationSelect"
                              :plain="true"
                              :options="qualificationsOptions"
                              v-model="qualification_id"
                              :class="{hasError: errors.qualification !== ''}"
                        >
                          <template #first>
                            <b-form-select-option :value="null">-- Sélectionner --</b-form-select-option>
                          </template>
                        </b-form-select>
                        <span class="field-error">{{ errors.qualification }}</span>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1" v-if="canDoAction()">
                    <b-col :sm="codeStatut === 'BR' ? 5 : 3">
                      <label for="action_fiche"><strong>{{ libelleAction }}:  </strong></label>
                      <label v-if="codeStatut === 'BR'"><i>(sous réserve d'avoir renseigné l'Email)</i></label>
                    </b-col>
                    <b-col sm="5">
                      <b-form-radio-group
                        id="radio-group-action"
                        v-model="action_fiche"
                        name="radio-action"
                      >
                        <b-form-radio value="false">Non</b-form-radio>
                        <b-form-radio value="true">Oui</b-form-radio>
                      </b-form-radio-group>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1" style="margin-left:0px;" v-if="codeStatut === 'CL'">
                    <label>Si une réactivation de la fiche est nécessaire, se rapprocher d'un encadrant</label>
                  </b-row>
                  <b-row class="mb-1" v-if="dossier_id !== null && traitement_id !== null">
                    <b-col sm="3" class="ref-dossier">
                      <label for="dossier"><strong>Référence dossier :</strong></label>
                    </b-col>
                    <b-col>
                      <router-link :to="{ path: '/espace-gestion/dossier/show/' + dossier_id + '?traitementId=' + traitement_id }">
                        {{ dossier_id }}
                      </router-link>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <div class="mt-1" slot="footer">
              <b-button type="button" @click="retour()" size="md" variant="secondary">
                <i class="fa fa-arrow-left"></i> Retour
              </b-button>
              <b-button v-if="showSubmitButton('enregistrement')" type="button" @click="submitForm('enregistrement')" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"></i> Enregistrer
              </b-button>
              <b-button type="button" @click="showModal" size="md" class="pull-right mr-2" variant="success" :disabled="!canCreateDossier()" v-if="dossier_id === null">
                <i class="fa fa-folder"></i> Créer un dossier
              </b-button>
              <b-button v-if="showSubmitButton('reactiver')" type="button" @click="submitForm('reactiver')" size="md" class="pull-right" variant="danger">
                <i class="fa fa-save"></i> Réactiver
              </b-button>
              <b-button v-if="showSubmitButton('brouillon')" type="button" @click="submitForm('brouillon')" size="md" class="pull-right mr-2" variant="warning">
                <i class="fa fa-sticky-note"></i> Brouillon
              </b-button>
            </div>
            <b-modal no-close-on-esc no-close-on-backdrop hide-header-close centered id="modal-relatedFiches" ref="modal-relatedFiches" title="Cloture des fiches liées">
              <label><b>Sélectionnez les fiches à clôturer simultanément</b></label>
              <ul>
                <b-row class="" v-for="relatedFiche in this.relatedFiches" :key="relatedFiche.id">
                  <b-form-checkbox v-model="selectedRelatedFiches" :value="relatedFiche.id"></b-form-checkbox>
                  <li>N° FC{{ relatedFiche.annee }}-{{ relatedFiche.numero_annee.toString().padStart(5, '0') }}</li>
                </b-row>
              </ul>
              <template v-slot:modal-footer>
                <div class="w-100 text-right">
                  <button type="button" class="btn btn-secondary mr-1" @click="closeModalRelatedFiche()">Annuler la clôture</button>
                  <button type="button" @click="submitForm('enregistrement')" class="btn btn-warning"><i class="fa fa-save"></i>
                    Confirmer la clôture
                  </button>
                </div>
              </template>
            </b-modal>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <!--  Modal pour l'ajour de dossier  -->
    <ModalFicheClientDossier ref="modalfichedossier" :donnees="donnees" />
  </div>
</template>


<script>
  import { formatDateTime } from "@/utils/communHelper"
  import { isEmpty } from "@/utils/fileHelper"
  import { hasRule, espaceRCRules as rules } from "@/utils/rulesHelper"
  import { getUser } from "@/utils/auth"
  import { isResponsable } from "@/utils/userHelper"
  import ModalFicheClientDossier from "@/components/ModalFicheClientDossier.vue"

  export default {
    name: 'ModalFiche',
    components: { ModalFicheClientDossier },
    data() {
      return {
        id: '',
        fiche: '',
        annee: '',
        numero_annee: '',
        contact_civ: '',
        contact_nom: '',
        contact_prenom: '',
        contact_fonction: null,
        contact_tel: '',
        contact_precision: '',
        contact_email: '',
        structure_nom: '',
        structure_siren: '',
        structure_nic: '',
        beneficiaire_nom: '',
        beneficiaire_prenom: '',
        beneficiaire_nir: '',
        beneficiaire_cle: '',
        demande_objet: '',
        demande_verification: '',
        produitOptions: [],
        selectedProduit: null,
        produit_precision: '',
        criticite: 'S',
        libelleStatut: '',
        codeStatut: '',
        libelleAction: 'Clore la Fiche ',
        typeAction: '',
        domaine: null,
        domaineOptions: [],
        notif: false,
        gestionnaire: null,
        gestionnaireOptions: [],
        qualification: null,
        qualificationsOptions: [],
        action_fiche: false,
        note_demande: '',
        type_suivi: 'C',
        ficheSuivis: [],
        qualification_id: null,
        garantieOptions: ['IJ','Inval','Décès'],
        selectedGarantie: null,
        relatedFiches: [],
        fromRelatedFiches: false,
        selectedRelatedFiches: [],
        traitement_id: '',
        errors: {
          contact_civ: '',
          contact_nom: '',
          contact_fonction: '',
          contact_tel: '',
          contact_email: '',
          selectedProduit: '',
          selectedGarantie: '',
          domaine: '',
          gestionnaire: '',
          qualification: '',
          note_demande: '',
          type_suivi: ''
        },
        dossier_id: '',
        status_id: '',
        demande_objet: '',
        donnees: {
          beneficiaire: {},
          structure: {},
          contact: {},
        },
      }
    },
    created() {
      this.id = this.$route.params.id
      this.getFiche(this.id)
      this.getGammeProduits()
      this.getDomaines()
      this.clearForm()
    },
    methods: {
      getDomaines() {
        this.domaineOptions = [];
        let self = this;
        this.$axios
          .get("/espaceRelationClient/fiches/domaines")
          .then(response => {
            for (let domaine of response.data.domaines) {
              this.domaineOptions.push({text: domaine.libelle, value: domaine.id});
            }
          })
          .catch(function(error) {
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des domaines. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              })
          })
      },
      getGestionnaires(domaine) {
        this.gestionnaireOptions = []
        this.$store.commit('IS_LOADING', true)
        let self = this
        this.$axios
          .get('/espaceRelationClient/fiche/gestionnaires/domaine/' + domaine)
          .then(response => {
            for (let gestionnaire of response.data.gestionnaires) {
              let infosGest = gestionnaire.prenom.charAt(0).toUpperCase() + '. ' + gestionnaire.nom.charAt(0).toUpperCase()+gestionnaire.nom.slice(1).toLowerCase()
              this.gestionnaireOptions.push({value: gestionnaire.user_id, text: infosGest})
            }
            this.$store.commit('IS_LOADING', false)
          })
          .catch(function (error) {
            console.log('error fiche', error)
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des gestionnaires. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              })
          })
      },
      getFiche(id) {
        this.$store.commit('IS_LOADING', true)
        let self = this
        this.$axios
          .get('/espaceRelationClient/fiche/edit/' + id)
          .then(response => {
            let fiche = response.data.fiche
            // console.log(response.data)
            this.setParams(fiche)
            this.motifCloture = response.data.motifs.find(value => value.id === fiche.qualification_id);
            this.relatedFiches = response.data.relatedFiches;
            for (let motif of response.data.motifs) {
              this.qualificationsOptions.push({value: motif.id, text: motif.libelle})
            }
            for (let gestionnaire of response.data.gestionnaires) {
              let infosGest = gestionnaire.prenom.charAt(0).toUpperCase() + '. ' + gestionnaire.nom.charAt(0).toUpperCase()+gestionnaire.nom.slice(1).toLowerCase()
              this.gestionnaireOptions.push({value: gestionnaire.user_id, text: infosGest})
            }
            this.status_id = fiche.status_id
            this.dossier_id = fiche.dossier_id
            this.traitement_id = fiche.traitement_id
            this.$store.commit('IS_LOADING', false)
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false)
            console.log('error fiche', error)
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération de la fiche. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              })
          })
      },
      setParams(fiche) {
        this.fiche = fiche
        this.annee = fiche.annee
        this.numero_annee = fiche.numero_annee.toString().padStart(5, '0')
        this.contact_civ = fiche.contact_civ
        this.contact_nom = fiche.contact_nom
        this.contact_prenom = fiche.contact_prenom
        this.contact_fonction = fiche.contact_fonction
        this.contact_tel = fiche.contact_tel
        this.contact_precision = fiche.contact_precision
        this.contact_email = fiche.contact_email
        this.structure_nom = fiche.structure_nom
        this.structure_siren = fiche.structure_siren
        this.structure_nic = fiche.structure_nic
        this.beneficiaire_nom = fiche.beneficiaire_nom
        this.beneficiaire_prenom = fiche.beneficiaire_prenom
        this.beneficiaire_nir = fiche.beneficiaire_nir ? fiche.beneficiaire_nir.substring(0,13) : ''
        this.beneficiaire_cle = fiche.beneficiaire_nir ? fiche.beneficiaire_nir.substring(13,15) : ''
        this.demande_objet = fiche.demande_objet
        this.demande_verification = fiche.demande_verification
        this.selectedProduit = fiche.produit_id
        this.produit_precision = fiche.produit_precision
        this.selectedGarantie = fiche.garantie
        this.criticite = fiche.type
        this.domaine = fiche.domaine_id
        this.notif = fiche.notif
        this.ficheSuivis = fiche.suivis
        this.libelleStatut = fiche.status ? fiche.status.libelle_front : ''
        this.codeStatut = fiche.status ? fiche.status.libelle_bo : ''
        if (this.codeStatut === 'AV') {
          this.libelleAction = 'Valider la Fiche '
          this.typeAction = 'valider'
        } else if (this.codeStatut === 'AT' || this.codeStatut === 'EC') {
          this.libelleAction = 'Clore la Fiche '
          this.typeAction = 'clore'
        } else if (this.codeStatut === 'BR') {
          this.libelleAction = "Envoi d'une notification au contact"
          this.typeAction = 'notification'
          this.action_fiche = fiche.notif
        }
        this.qualification_id = fiche.qualification_id
      },
      getGammeProduits() {
        this.produitOptions = [];
        let self = this;
        this.$axios
          .get('/espaceRelationClient/fiche-niv2/produits')
          .then(response => {
            // pour une meilleur performance
            this.produitOptions = response.data.produits.map(row => ({
              text: row.libelle,
              value: row.id
            }));
          })
          .catch(function(error) {
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des produits. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              })
          })
      },
      closeModalRelatedFiche(){
        this.$refs['modal-relatedFiches'].hide();
        this.fromRelatedFiches = false;
        this.selectedRelatedFiches = [];
        return false;
      },
      submitForm(state) {
        if (this.validateData()) {
          if(this.typeAction === 'clore' && this.action_fiche === 'true' && this.relatedFiches.length > 0 && this.fromRelatedFiches === false){
            this.$refs['modal-relatedFiches'].show();
            this.fromRelatedFiches = true;
            return false;
          }

          if(this.fromRelatedFiches === true){
            this.$refs['modal-relatedFiches'].hide();
            this.fromRelatedFiches = false;
          }

          this.$store.commit('IS_LOADING', true)
          let self = this
          let dataPost = {}
          dataPost.id = this.id
          dataPost.gestionnaire_id = this.gestionnaire
          dataPost.contact_civ = this.contact_civ
          dataPost.contact_nom = this.contact_nom
          dataPost.contact_prenom = this.contact_prenom
          dataPost.contact_fonction = this.contact_fonction
          dataPost.contact_tel = this.contact_tel
          dataPost.contact_precision = this.contact_precision
          dataPost.contact_email = this.contact_email
          dataPost.structure_nom = this.structure_nom
          dataPost.structure_siren = this.structure_siren
          dataPost.structure_nic = this.structure_nic
          dataPost.beneficiaire_nom = this.beneficiaire_nom
          dataPost.beneficiaire_prenom = this.beneficiaire_prenom
          dataPost.beneficiaire_nir = this.beneficiaire_nir + this.beneficiaire_cle
          dataPost.demande_objet = this.demande_objet
          dataPost.demande_verification = this.demande_verification
          dataPost.produit_id = this.selectedProduit
          dataPost.produit_precision = this.produit_precision
          dataPost.garantie = this.selectedGarantie
          dataPost.type = this.criticite
          dataPost.domaine_id = this.domaine
          dataPost.notif = this.notif
          dataPost.type_suivi = this.type_suivi
          dataPost.note_demande = this.note_demande
          dataPost.qualification_id = this.qualification_id
          dataPost.type_action = this.typeAction
          dataPost.action_fiche = this.action_fiche
          dataPost.relatedFiches = this.selectedRelatedFiches;
          dataPost.state = state
          this.$axios.post('/espaceRelationClient/fiche/store', dataPost)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              let fiche = response.data.fiche.fiche
              let criticiteSelected = fiche.type == 'S' ? 'Standard' : fiche.type == 'R' ? 'Réclamation' : fiche.type == 'U' ? 'Urgent' : ''
              //let confirmation = '<span>Demande client enregistrée</span><br><span>Numéro de la demande : FC' + fiche.annee + '-' + fiche.numero_annee.toString().padStart(5,'0') +'</span><br><br><span>Criticité : ' + criticiteSelected + '</span><br>' + response.data.fiche.emailNotif
              // console.log('confirmation', confirmation)

              this.ficheSuivis = fiche.suivis
              this.clearForm()
              this.$swal({ position: 'top', type: 'success', html: 'Mise à jour de la fiche avec succès', showConfirmButton: false, timer: 5000 })
              if (state === 'reactiver' || (state === 'enregistrement' && this.fiche.status.libelle_bo === 'BR')) {
                this.getFiche(this.id);
              } else {
                this.setParams(fiche)
              }
            })
            .catch(function (error) {
              console.log(error)
              self.$store.commit('IS_LOADING', false)
              self.$swal({ position: 'top', type: 'error', title: 'Attention !!', text: 'Une erreur est survenue pendant l\'enregistrement. Si le problème persiste contactez le support DOSI.', showConfirmButton: false, timer: 5000 })
            })
        }else{
          let self = this
          self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Un ou plusieurs champs obligatoires n\'ont pas été renseignés',
                showConfirmButton: false,
                timer: 3000
              })
        }
      },
      validateData() {
        this.clearErrors()
        let valid = true
        if (this.contact_civ == '') {
          this.errors.contact_civ = "Veuillez renseigner la civilité du contact"
          valid = false
        }
        if (this.contact_nom == '') {
          this.errors.contact_nom = "Le nom du contact est obligatoire"
          valid = false
        }
        if (this.contact_fonction == '') {
          this.errors.contact_fonction = "Veuillez renseigner la fonction du contact"
          valid = false
        }
        if (this.contact_tel !== '') {
          this.contact_tel = this.contact_tel.replaceAll(' ', '')
          if (this.contact_tel.length < 10 || this.contact_tel.length > 10) {
            this.errors.contact_tel = "Le numéro de téléphone doit contenir 10 chiffres"
            valid = false
          }
          if (/^\d+$/.test(this.contact_tel) === false) {
            this.errors.contact_tel = "Le numéro de téléphone ne doit contenir que des chiffres"
            valid = false
          }
        } else {
          this.errors.contact_tel = "Le numéro de téléphone du contact est obligatoire"
          valid = false
        }
        if (this.contact_email == '') {
          this.errors.contact_email = "L'adresse email du contact est obligatoire"
          valid = false
        }
        if (this.selectedProduit == null) {
          this.errors.selectedProduit = "Veuillez choisir une gamme produit"
          valid = false
        }
        if (this.domaine == null) {
          this.errors.domaine = "Veuillez choisir le destinataire"
          valid = false
        }

        if(this.note_demande == '' && this.typeAction === 'clore' && this.action_fiche === 'true' ){
          this.errors.note_demande = "Vous devez saisir une note pour clôturer la fiche"
          valid = false
        }

        return valid
      },
      clearForm() {
        this.gestionnaire = null
        this.type_suivi = 'C'
        this.note_demande = ''
      },
      clearErrors() {
        this.errors.contact_civ = ''
        this.errors.contact_nom = ''
        this.errors.contact_fonction = ''
        this.errors.contact_tel = ''
        this.errors.contact_email = ''
        this.errors.selectedProduit = ''
        this.errors.domaine = ''
      },
      cancelForm() {
        this.$bvModal.hide('modal-fiche')
        this.clearErrors()
      },
      formatDateHeure(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-";
        return date;
      },
      getFormattedDateTime(textDate) {
        if(textDate !== null && textDate !== ''){
          return formatDateTime(textDate, '-');
        }
      },
      isDisabled(champ) {
        if (this.codeStatut === 'CL' && champ !== 'note_demande') {
          return true
        }
        if (!hasRule(rules.CAN_MANAGE_FICHES_NIV2)) {
          return true
        }
        let user = getUser()

        if (champ === 'demande_objet' || champ === 'demande_verification') {
          if ((this.codeStatut === 'AV' || this.codeStatut === 'BR') && user.id === this.fiche.createur.id) {
            return false
          } else {
            return true
          }
        }
        return false
      },
      canDoAction() {
        let response = true
        if (this.codeStatut === 'CL') {
          response = false
        }
        if (this.codeStatut === 'AV' && !hasRule(rules.CAN_VALIDATE_FICHE)) {
          response = false
        }
        if ((this.codeStatut === 'AT' || this.codeStatut === 'EC') && !hasRule(rules.CAN_MANAGE_FICHES_NIV2)) {
          response = false
        }

        return response
      },
      canReactivate() {
        return isResponsable()
      },
      canDeleteSuivi(suivi, index) {
        let user = getUser()
        
        let echange_client = suivi.texte.substring(19, 30) 
        let echange_interne = suivi.texte.substring(19, 31)
        if (!isEmpty(suivi.gestionnaire)) {
          return index === (this.ficheSuivis.length - 1) && user.id === suivi.gestionnaire.id && (echange_client === 'Ech. Client' || echange_interne == 'Ech. Interne')
        } else {
          return false
        }
        
      },
      deleteSuivi(suivi) {
        let self = this
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment supprimer cet échange ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor:"#ff1744",
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (result.value !== true) {
            this.$store.commit('IS_LOADING', true)
            this.$axios.delete('/espaceRelationClient/fiche-niv2/suivi/delete/'+suivi.id)
              .then(response => {
                this.$store.commit('IS_LOADING', false)
                this.ficheSuivis = response.data.suivis

                this.$swal({ position: 'top', type: 'success', title: 'Succès', text: 'Suppression de l\'échange avec succès', showConfirmButton: false, timer: 5000 })
              })
              .catch(function (error) {
                console.log(error)
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'error', title: 'Attention !!', text: 'Une erreur est survenue pendant la suppression. Si le problème persiste contactez le support DOSI.', showConfirmButton: false, timer: 5000 })
              })
          }
        })
        
      },
      showSubmitButton(type) {
        if (!isEmpty(this.fiche)) {
          if (type === 'brouillon') {
            let user = getUser()
            return this.fiche.status.libelle_bo === 'BR' && user.id === this.fiche.createur_id && hasRule(rules.CAN_MANAGE_FICHES_NIV2)
          } else if (type === 'reactiver') {
            return this.fiche.status.libelle_bo === 'CL' && hasRule(rules.CAN_MANAGE_FICHES_NIV2)
          } else if (type === 'enregistrement') {
            return this.fiche.status.libelle_bo !== 'CL' && hasRule(rules.CAN_MANAGE_FICHES_NIV2)
          }
        }
        return false
      },
      retour() {
        this.$router.push({path: '/espace-rc/fiches-niveau2', query: this.$route.query})
      },
      showModal() {
        this.donnees = {
          fiche_id: this.id,
          beneficiaire: {
            nom: this.beneficiaire_nom,
            prenom: this.beneficiaire_prenom,
            nir: this.beneficiaire_nir
          },
          structure: {
            rs: this.structure_nom,
            siren: this.structure_siren,
            nic: this.structure_nic
          },
          contact: {
            nom: this.contact_nom,
            tel: this.contact_tel,
            email: this.contact_email,
          },
          produitId: this.selectedProduit,
          selectedProduct: this.productSelected ? this.productSelected.text : null,
          selectedGarantie: this.selectedGarantie,
          demande_objet: this.demande_objet,
          demandeClientNum: 'FC'+this.annee+'-'+this.numero_annee,
        }
        this.$refs.modalfichedossier.openModal()
      },
      canCreateDossier() {
        let response = true
          if(!this.beneficiaire_nom || !this.beneficiaire_prenom || !this.beneficiaire_nir || !this.structure_nom || !this.structure_siren || !this.structure_nic || !this.contact_nom || !this.contact_prenom || !this.contact_email || !this.selectedProduit || !this.selectedGarantie || !this.status_id) {
          response = false
        }
        return response
      },
    },
    computed: {
      productSelected() {
        return this.produitOptions.find(opt => Number(opt.value) === Number(this.selectedProduit));
      }
    },
  }
</script>

<style>
  span.vert {
    color: green;
    font-weight: bold;
  }
  span.noir {
    color: #000;
    font-weight: bold;
    font-style: italic;
  }
  span.suivi_italic {
    color: #000;
    font-weight: normal;
    font-style: italic;
  }
  span.rouge {
    color: #C72C48;
    font-weight: bold;
  }

  .ref-dossier {
    max-width: 30%;
  }
  
</style>
